<template>
    <div class="domestic">
        <headers :title="$t('下载')" img="domestic"></headers>
            <el-row style="margin-top:2rem;margin-bottom:3rem;display:none">
                <el-col :span="14" :offset="5"><div class="text">
                    {{$t('我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。')}}
                    </div>
                </el-col>
            </el-row>
             <div class="Cooperation">
        <el-row style="margin-top:2rem;">
            <el-col :span="14" :offset="5">
                <div class="line"></div>
                <el-row>
                    <el-col class="list" :span="6" :offset="index%2==0?0:8" v-for="(item, index) in iconList" :key="index">
                        <a :href="`/${item}.pdf`" class="list-item">
                        <svg class="list-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="#B1A9FF" d="M12 19q1.675 0 2.838-1.175T16 15v-3q0-.425-.288-.712T15 11q-.425 0-.712.288T14 12v3q0 .825-.575 1.413T12 17q-.825 0-1.412-.587T10 15V9.5q0-.225.15-.363T10.5 9q.225 0 .363.138T11 9.5V14q0 .425.288.713T12 15q.425 0 .713-.288T13 14V9.5q0-1.05-.725-1.775T10.5 7q-1.05 0-1.775.725T8 9.5V15q0 1.65 1.175 2.825T12 19m-6 3q-.825 0-1.412-.587T4 20V4q0-.825.588-1.412T6 2h9l5 5v13q0 .825-.587 1.413T18 22zm8-18v3q0 .425.288.713T15 8h3z"/></svg>
                          <div>{{item}}</div>
                        </a>
                    </el-col>
                </el-row>
                <div class="line"></div>
                
            </el-col>
        </el-row>
    </div>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import Cooperation from "@/components/Cooperation.vue";
export default {
    data() {
        return {
            iconList:[
                'YC2055_DoC',
                'YC2035_DoC',
                'YC3010_DoC',
                'YC2040_DoC',
                'YC2091_DoC',
                'YC2031_DoC',
                'YC2092_DoC',
                '240801_DoC',
                'YC2036_DoC',
            ]
        }
    },
    components:{
      headers,foot,Cooperation
    }
}
</script>
<style lang="less">
.list-item {
  min-width: 160px;
  display: flex;
  gap: 8px;
  align-items: center;
}
.list-icon {
  width: 24px;
  height: 24px;
  color: #B1A9FF
}
.domestic{
    .btn{
        line-height: 3rem;
        font-size: 0.8rem;
        cursor: pointer;
        white-space:nowrap;
    }
    .domesticBtn a{
        color: #A0A0A0;  
        text-decoration: none;      
    }
    .InternationalBtn a{
        color: #565656;
        text-decoration: none;
    }
    .line{
        height: 1px;
        width: 100%;
        background-color: #BFBFBF;
    }
    .title{
        font-size: 1.6rem;
        text-align: center;
        font-weight: bold;
        color: #747474;
        margin-top: 5rem;
        margin-bottom: 3rem;
    }
    .text{
        text-align: center;
        font-size: 0.75rem;
        color: #737373;
        line-height: 1.4rem;
        span{
            color: #017CA8;
        }
    }
}
</style>
<i18n>
{
  "en": {
    "国内业务":"Domestic Business",
    "国际业务":"International Business",
    "我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。":"Our customers are located in various provinces and cities across the country. At home, we mainly provide OEM production for several large domestic medical supplies production companies, such as Wenjian. Recognized in the industry with high quality. At the same time, it also provides a lot of general protective equipment for domestic animal husbandry.",
    "下载":"Download"
  },
  "zh": {
    "国内业务":"国内业务",
    "国际业务":"国际业务",
    "我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。":"我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。",
    "下载":"下载"
  }
}
</i18n>

